import styled from 'styled-components'

export const FlexRow = styled.div`
  align-items: ${(props) => (props.alignCenter ? 'center' : props.alignEnd ? 'flex-end' : 'flex-start')};
  display: flex;
  justify-content: ${(props) =>
    props.spaceBetween ? 'space-between' : props.$end ? 'flex-end' : props.center ? 'center' : 'flex-start'};
  gap: ${(props) => props.gap || '0px'};
  margin: ${(props) => props.margin || '0px'};
`

export const FlexColumn = styled.div`
  align-items: ${(props) => (props.alignCenter ? 'center' : 'flex-start')};
  display: flex;
  flex-direction: column;
  min-height: ${(props) => props.minHeight || 'auto'};
`
